$(document).ready(function () {
  // Turbo will not enable this button again once the form is submitted. Since a new tab is being opened, it seems like the button isn't getting enabled again.
  $(document).on("click", "#export-csv-button-js", function () {
    let button = $(this);
    setTimeout(() => button.prop("disabled", false), 500);
  });
});
